import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import { Route } from 'routes';
import { setDefaultFiltersAction } from '../slice';

const setDefaultFiltersOperation =
  (activeRoute?: Route) => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    if (!activeRoute || !activeRoute.categoryId) return;

    const defaultFilters = {
      searchCategoryIds: [String(activeRoute.categoryId)],
    };

    dispatch(setDefaultFiltersAction(defaultFilters));
  };

export default setDefaultFiltersOperation;
